import { ModalErrorContent } from '@sleepstation/components'
import { ModalContainer } from '@sleepstation/components-hooks'
import React from 'react'
import getErrorService from '../services/errorService'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const NON_FATAL_LABEL = `Try again`
const FATAL_LABEL = `Refresh Page`

const { handleError } = getErrorService()

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const refreshPage = () => {
  window.location.reload()
}

const getDefaultButtonLabel = (isFatal) =>
  isFatal ? FATAL_LABEL : NON_FATAL_LABEL

const getDefaultButtonCallback = (isFatal, closeModal) =>
  isFatal ? refreshPage : closeModal

// -----------------------------------------------------------------------------
// Hook
// -----------------------------------------------------------------------------

const useDisplayError = () => {
  const { openModal, closeModal } = ModalContainer.useContainer()

  const displayError = (
    message,
    error,
    { isFatal = true, buttonCallback, buttonLabel } = {}
  ) => {
    // This gives the app an opportunity to handle the error. For example to
    // redirect a 401.
    handleError(error)

    const resolvedButtonCallback =
      buttonCallback || getDefaultButtonCallback(isFatal, closeModal)
    const resolvedButtonLabel = buttonLabel || getDefaultButtonLabel(isFatal)

    openModal({
      // eslint-disable-next-line react/display-name
      Component: () => (
        <ModalErrorContent
          handleClose={resolvedButtonCallback}
          body={`${message}: ${error.message}`}
          buttonLabel={resolvedButtonLabel}
        />
      ),
    })
  }

  return { displayError }
}

export default useDisplayError
